import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import _, { noop } from 'lodash';
import Slider from 'react-slick';
import classnames from 'classnames/bind';
import Icon from '../../elementals/icon';
import { CAROUSEL_DEFAULT_SPEED_MS } from '../../../constants/statics';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const elmId = 'carousel';
const Arrow = ({ isBackArrow, move, onClick, className = '', alwaysShowArrows, alwaysHideArrows, customClassName = '', arrowIconProps = {}, }) => {
    let iconName = isBackArrow ? arrowIconProps.backName : arrowIconProps.nextName;
    iconName = iconName || isBackArrow ? 'angle-left' : 'angle-right';
    const arrowElmId = arrowIconProps.elmId || elmId;
    return (!alwaysHideArrows && (_jsx(Icon, { iconStyle: 'regular', name: iconName, color: 'white', size: 'huge', fitted: true, "data-elm-id": isBackArrow
            ? `${arrowElmId}_carousel_back_arrow`
            : `${arrowElmId}_carousel_next_arrow`, className: cx(isBackArrow ? 'back-arrow' : 'next-arrow', {
            disabled: className.includes('slick-disabled') && !alwaysShowArrows,
        }, customClassName), onClick: event => {
            move(event);
            onClick(event);
        }, ..._.omit(arrowIconProps, 'backName', 'nextName', 'elmId') })));
};
const arrowPropTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    alwaysShowArrows: PropTypes.bool,
    alwaysHideArrows: PropTypes.bool,
    customClassName: PropTypes.string,
    arrowIconProps: PropTypes.object,
};
Arrow.propTypes = {
    isBackArrow: PropTypes.bool,
    move: PropTypes.func,
    ...arrowPropTypes,
};
export const NextArrow = ({ next, ...props }) => (_jsx(Arrow, { ...props, isBackArrow: false, move: next }));
NextArrow.propTypes = {
    ...arrowPropTypes,
    next: PropTypes.func,
};
export const BackArrow = ({ back, ...props }) => (_jsx(Arrow, { ...props, isBackArrow: true, move: back }));
BackArrow.propTypes = {
    ...arrowPropTypes,
    back: PropTypes.func,
};
export default class Carousel extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.node,
            PropTypes.arrayOf(PropTypes.node),
        ]).isRequired,
        alwaysShowArrows: PropTypes.bool,
        alwaysHideArrows: PropTypes.bool,
        settings: PropTypes.object,
        arrowIconProps: PropTypes.object,
        elmId: PropTypes.string,
        next: PropTypes.func,
        back: PropTypes.func,
        carouselRef: PropTypes.object,
    };
    static defaultProps = {
        alwaysShowArrows: false,
        alwaysHideArrows: false,
        settings: {},
        arrowIconProps: {},
        next: noop,
        back: noop,
    };
    constructor(props) {
        super(props);
        if (props.carouselRef) {
            this.sliderRef = props.carouselRef;
        }
        else {
            this.sliderRef = createRef();
        }
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }
    goToSlide = index => {
        if (this.sliderRef.current) {
            this.sliderRef.current.slickGoTo(index);
        }
    };
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    handleKeyDown(event) {
        if (!this.sliderRef.current)
            return;
        if (event.key === 'ArrowRight') {
            this.sliderRef.current.slickNext();
        }
        else if (event.key === 'ArrowLeft') {
            this.sliderRef.current.slickPrev();
        }
    }
    render() {
        const { children, settings, next, back, alwaysShowArrows, alwaysHideArrows, arrowIconProps, elmId, ...props } = this.props;
        const defaultSettings = {
            speed: CAROUSEL_DEFAULT_SPEED_MS,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: (_jsx(NextArrow, { next: next, alwaysShowArrows: alwaysShowArrows, alwaysHideArrows: alwaysHideArrows, arrowIconProps: arrowIconProps })),
            prevArrow: (_jsx(BackArrow, { back: back, alwaysShowArrows: alwaysShowArrows, alwaysHideArrows: alwaysHideArrows, arrowIconProps: arrowIconProps })),
        };
        const finalSettings = Object.assign({}, defaultSettings, settings);
        return (_jsx("div", { "data-elm-id": `${elmId}_carousel`, children: Slider && (_jsx(Slider, { ref: this.sliderRef, ...finalSettings, ...props, children: children })) }));
    }
}
//# sourceMappingURL=index.js.map